import { FC, useEffect, useMemo, useState } from "react";
import { ConfirmButton, ConfirmContent, ConfirmText, ConfirmWrapper, DeclineButton, UnfinishedLesson } from "./styles";
import { FlexBox } from "@brg/ui";
import { useTranslation } from "react-i18next";
import { API, Endpoints } from "@brg/api";
import { IConfirmCourseCompletionModalProps, ICourseReadinessForCompletionResponse, IUnfinishedLesson } from "./types";
import { computeDataWithLang } from "shared/helpers/types/computed/ComputedTeam";

export const ConfirmCourseCompletionModal: FC<IConfirmCourseCompletionModalProps> = ({ teamId, handleClose, handleComplete }) => {
  const { t } = useTranslation();

  const [readinessResponse, setReadinessResponse] = useState<ICourseReadinessForCompletionResponse | null>();

  const currentDomain = useMemo(() => {
    return window?.location?.origin;
  }, []);

  useEffect(() => {
    if (teamId) {
      API.request()
        .endpoint(Endpoints.geograffee)
        .url("/api/lms/GetCourseReadinessForCompletion")
        .get()
        .addQuery("teamId", teamId)
        .send()
        .then((r) => r.json())
        .then((r) => {
          setReadinessResponse(r);
        })
        .catch((e) => console.error(e));
    }
  }, [teamId]);

  return (
    <ConfirmWrapper>
      <ConfirmContent direction="column">
        <ConfirmText>{t("teams.adminPage.modal.confirmCourseCompletion.text")}</ConfirmText>

        {readinessResponse?.unfinishedLessons && readinessResponse?.unfinishedLessons.length > 0 ? (
          <>
            {t("teams.adminPage.modal.confirmCourseCompletion.unfinished_lessons")}
            {readinessResponse.unfinishedLessons.map((l: IUnfinishedLesson) => (
              <UnfinishedLesson>
                <a href={`${currentDomain}/team-edit/${teamId}`} target="blank">{l.name[0]?.name}</a>
              </UnfinishedLesson>
            ))}
          </>
        ) : (
          t("teams.adminPage.modal.confirmCourseCompletion.ready_to_complete")
        )}
        <FlexBox gx={24} gxMobile={"0"} gyMobile={16} direction="row" directionMobile="column" offsetTop={24} justify="center">
          <ConfirmButton fixedSize onClick={handleComplete}>
            {t("teams.adminPage.modal.confirmCourseCompletion.buttons.hollow")}
          </ConfirmButton>
          <DeclineButton fixedSize onClick={handleClose}>
            {t("teams.adminPage.modal.confirmCourseCompletion.buttons.filled")}
          </DeclineButton>
        </FlexBox>
      </ConfirmContent>
    </ConfirmWrapper>
  );
};
import { FC, useEffect, useMemo, useState } from "react";
import { ConfirmButton, ConfirmContent, ConfirmText, ConfirmWrapper, DeclineButton, UnfinishedLesson } from "./styles";
import { FlexBox } from "@brg/ui";
import { useTranslation } from "react-i18next";
import { API, Endpoints } from "@brg/api";
import { IConfirmCourseCompletionModalProps, ICourseReadinessForCompletionResponse, IUnfinishedLesson } from "./types";
import { computeDataWithLang } from "shared/helpers/types/computed/ComputedTeam";

export const ConfirmCourseCompletionModal: FC<IConfirmCourseCompletionModalProps> = ({ teamId, handleClose, handleComplete }) => {
  const { t } = useTranslation();

  const [readinessResponse, setReadinessResponse] = useState<ICourseReadinessForCompletionResponse | null>();

  const currentDomain = useMemo(() => {
    return window?.location?.origin;
  }, []);

  useEffect(() => {
    if (teamId) {
      API.request()
        .endpoint(Endpoints.geograffee)
        .url("/api/lms/GetCourseReadinessForCompletion")
        .get()
        .addQuery("teamId", teamId)
        .send()
        .then((r) => r.json())
        .then((r) => {
          setReadinessResponse(r);
        })
        .catch((e) => console.error(e));
    }
  }, [teamId]);

  return (
    <ConfirmWrapper>
      <ConfirmContent direction="column">
        <ConfirmText>{t("teams.adminPage.modal.confirmCourseCompletion.text")}</ConfirmText>

        {readinessResponse?.unfinishedLessons && readinessResponse?.unfinishedLessons.length > 0 ? (
          <>
            {t("teams.adminPage.modal.confirmCourseCompletion.unfinished_lessons")}
            {readinessResponse.unfinishedLessons.map((l: IUnfinishedLesson) => (
              <UnfinishedLesson>
                <a href={`${currentDomain}/team-edit/${teamId}`} target="blank">{l.name[0]?.name}</a>
              </UnfinishedLesson>
            ))}
          </>
        ) : (
          t("teams.adminPage.modal.confirmCourseCompletion.ready_to_complete")
        )}
        <FlexBox gx={24} gxMobile={"0"} gyMobile={16} direction="row" directionMobile="column" offsetTop={24} justify="center">
          <ConfirmButton fixedSize onClick={handleComplete}>
            {t("teams.adminPage.modal.confirmCourseCompletion.buttons.hollow")}
          </ConfirmButton>
          <DeclineButton fixedSize onClick={handleClose}>
            {t("teams.adminPage.modal.confirmCourseCompletion.buttons.filled")}
          </DeclineButton>
        </FlexBox>
      </ConfirmContent>
    </ConfirmWrapper>
  );
};
